module.exports = __webpack_public_path__ + "static/media/Truck.b51ac73a.svg";